// extracted by mini-css-extract-plugin
module.exports = {"header":"summary-panel_header__1cTzm","question":"summary-panel_question__1Au1L"};